import { Tag, Tooltip, Typography } from 'antd'
import React, { useMemo } from 'react'

import { PROPERTY_TYPES } from '../../../common/drmTypes'
import { insolvencyUrl } from '../../utils/propertyMonitoringHelpers'
import { useFetchAddressDetail } from '../../utils/useFetchAddressDetail'
import { useFetchSubjectDetail } from '../../utils/useFetchSubjectDetail'
import { MunicipalOfficeIndicator } from '../MunicipalOfficeIndicator/MunicipalOfficeIndicator'
import { PropertyDetailLink } from '../PropertyDetailLink/PropertyDetailLink'

interface SubjectDetailPageTitleProps {
  subjectId?: string
}
const style = { marginBottom: 0 }

export const SubjectDetailPageTitle: React.FC<SubjectDetailPageTitleProps> =
  props => {
    const { data: subject } = useFetchSubjectDetail(props.subjectId)
    const { data: address } = useFetchAddressDetail(subject?.adresniMistoKod)

    const insolvencies = useMemo(() => {
      if (subject?.insolvence) {
        return subject.insolvence.map((insolvency, index) => (
          <Tooltip
            key={index}
            title="Zobrazit detail insolvenčního řízení v novém okně"
          >
            <a
              href={insolvencyUrl(insolvency?.spisovaZnacka)}
              target="_blank"
              rel="noreferrer"
              className="flex items-center"
            >
              <Tag color="error" className="!mr-0 truncate hover:opacity-80">
                {insolvency?.stav} - {insolvency?.spisovaZnacka}
              </Tag>
            </a>
          </Tooltip>
        ))
      }
      return null
    }, [subject?.insolvence])

    return (
      <>
        <div className="flex space-x-4 items-center w-full">
          <Typography.Title style={style} level={3}>
            {subject?.jmeno || 'Detail subjektu'}
          </Typography.Title>
          <div className="flex pt-1 space-x-2">{insolvencies}</div>
        </div>

        <div className="flex items-center">
          <span className="text-gray-400">Adresa subjektu:</span>{' '}
          {address?.budovaId ? (
            <>
              <MunicipalOfficeIndicator
                className="mx-1 text-gray-400"
                addressId={subject?.adresniMistoKod}
              />
              <PropertyDetailLink
                text={address.formatovanaAdresa || '---'}
                propertyId={address.budovaId}
                propertyType={PROPERTY_TYPES.BUILDING}
                drawerTarget
              />
            </>
          ) : (
            subject?.adresa || '---'
          )}
        </div>
      </>
    )
  }
